<app-nav-menu></app-nav-menu>
<p-toast></p-toast>
<div class="cms_card">

  <div class="row-card">


    <div class="cms_card-heading"></div>

    <div class="addnewbutton">
      <p class="headingpage">ImportPNR Entry List</p>
      <a class="card-icon" (click)="popupCreateModel()">
        <i class="uil uil-file-plus-alt card_custom-icon"></i>
        <span class="card_custom-name">Add New</span>
      </a>
    </div>
  </div>


  <div>
    <p-dialog header="Create Import Pnr Entry" [modal]="true" [(visible)]="createairportmodal" [style]="{ width: '50rem' }">
    
        <div style="margin-top:10px">
          <form class="form-line-active popuplabel">
            <div class="form-row">

              <div class="col-md-6 mb-1 drophead">
                <label id="finalTicketLabel" for="validationServer03">
                  Supplier Code
                </label>
                <p-select class="segmentDropdown" [options]="supplierList" [required]="true" name="supplier" (onChange)="changeSupplier(createobj.supplier)" id="supplier"
                            [(ngModel)]="createobj.supplier" placeholder="Select supplier" optionLabel="name" optionValue="supplierId"></p-select>


                <span class=" inputErrors" id="supplierCodeInfoError">
                 
                </span>
              </div>

              <div class="col-md-6 mb-1 drophead" style="position: relative;">

                <label id="OfficeIDlabel" for="validationServer03">
                  PCC
                </label>

                <p-select class="segmentDropdown" [options]="officeidListForBind" [disabled]="!supplierAdded" [required]="true" id="pccId" name="pcc"
                            [(ngModel)]="createobj.pcc" placeholder="Select pcc" optionLabel="officeId" optionValue="officeId"></p-select>

                <p class=" inputErrors" id="pccValid" >
                  
                </p>
              </div>


            </div>
            <div class="form-row">
              <div class="col-md-6 mb-2 drophead">
                <label for="validationServer03">
                  Airline
                </label>
                <p-select class="multiselectDropDown" [options]="airlineMasterinfo" [(ngModel)]="createobj.airline"
                            
                            placeholder="Select Airlines" optionLabel="airlineLegalName" optionValue="airlinePrefixCode" id="airline"
                            name="airlines">
                </p-select>
                <span class=" inputErrors" id="messageAirline" >
                 
                </span>
              </div>

              <div class="col-md-6 mb-2">
                <label for="validationServer04">Entry</label>
                <input type="text" class="form-control" name="Entry" 
                       [(ngModel)]="createobj.entry" id="entry" placeholder="Please Enter Entry" required>
                <span class="messageRequiredCreate" id="messageEntry"></span>
              </div>

            </div>
            <div style=" display: flex; justify-content: center;">
              <button class="btn submitButton" (click)="CreateImportPnrEntry()" type="submit">Create</button>
            </div>

          </form>
        </div>
  
    </p-dialog>
  </div>

  <!-- Update ImportPnrEntry -->
  <div>
    <p-dialog header="Update Import Pnr Entry" [modal]="true" [(visible)]="updateairportmodal" [style]="{ width: '50rem' }">

    
      
        <div style="margin-top:10px">
          <form class="form-line-active popuplabel">
            <div class="form-row">

              <div class="col-md-6 mb-1 drophead">
                <label id="finalTicketLabel" for="validationServer03">
                       
                  Supplier Code
                </label>
                <p-select class="segmentDropdown" [options]="supplierList" [required]="true" id="supplier" name="supplier" (onChange)="changeSupplier(newobj.supplier)"
                            [(ngModel)]="newobj.supplier" placeholder="Select supplier" optionLabel="name" optionValue="supplierId"></p-select>


                <span class=" inputErrors" id="supplierCodeInfoError"></span>
              </div>

              <div class="col-md-6 mb-1 drophead" style="position: relative;">

                <label id="OfficeIDlabel" for="validationServer03">
                  PCC
                </label>

                <p-select class="segmentDropdown" [options]="officeidListForBind" [required]="true" id="pcc" name="pcc"
                            [(ngModel)]="newobj.pcc" placeholder="Select pcc" optionLabel="officeId" optionValue="officeId"></p-select>


                <span id="messagePcc">
                </span>
              </div>


            </div>
            <div class="form-row">
              <div class="col-md-6 mb-2 drophead">
                <label for="validationServer03">
                  Airline
                </label>
                <p-select class="multiselectDropDown" [options]="airlineMasterinfo" [(ngModel)]="newobj.airline"
                            placeholder="Select Airlines" optionLabel="airlineLegalName" optionValue="airlinePrefixCode" id="airline"
                            name="airlines" >
                </p-select>
                <span id="messageAirline">
                </span>
              </div>

              <div class="col-md-6 mb-2">
                <label for="validationServer04">Entry</label>
                <input type="text" class="form-control" name="Entry" 
                       [(ngModel)]="newobj.entry" id="entry" placeholder="Please Enter Entry" required>
                <span class="messageRequiredCreate" id="messageEntry"></span>
              </div>

            </div>
            <div style=" display: flex; justify-content: center;">
              <button class="btn submitButton" (click)="UpdateImportPnrEntry()" type="submit">Update</button>
            </div>
          </form>
        </div>
        <!--<button type="submit" (click)="SelectedRows()" class="profilesearchbutton">Submit</button>-->


    
      <!--<div id="employeeInfo" *ngIf="grid.selectedRowKeys.length">
    <input [value]="grid.instance.getSelectedRowsData()[0].lastName" />
  </div>-->
      </p-dialog>
</div>





  <div class="row cms_tabel">
    <div id="grids">
      <dx-data-grid id="grid" [dataSource]="importPnrEntry" [showBorders]="true" [showRowLines]="true"
                    (onContentReady)="contentReady($event)">


        <dxo-selection mode="single"></dxo-selection>
        <dxo-paging [pageSize]="100"></dxo-paging>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxi-column [visible]="false" dataType="number" dataField="id" alignment="center"></dxi-column>

        <!--<dxi-column dataField="icaoCode" caption="ICAO Code" dataType="string" alignment="center"></dxi-column>-->
        <dxi-column dataField="importPNREntryID" caption="importPNREntryID" [visible]="false" dataType="number" alignment="center"></dxi-column>
        <dxi-column dataField="supplier" caption="supplier" dataType="string" alignment="center"></dxi-column>
        <dxi-column dataField="pcc" caption="pcc" [width]="300" dataType="string"
                    alignment="center"></dxi-column>
        <dxi-column dataField="airline" caption="airline" dataType="string" alignment="center"></dxi-column>
        <dxi-column dataField="entry" caption="entry" dataType="string" alignment="center"></dxi-column>





        <dxi-column caption="Action" [allowSorting]="false" alignment="center"
                    cellTemplate="actionCellTemplate"></dxi-column>


        <div *dxTemplate="let data of 'actionCellTemplate'">
          <div class="card_buttons">
            <a class="card_button-edit" (click)="updatepopup(data.data)">
              <i class="uil uil-edit card_button-icon"></i>
            </a>
            <a class="cardBlock" (click)="DeleteAirport(data.data.importPNREntryID,sweet,bad)">
              <i class="">

                <img class="imageBlock" src="assets/img/remove.png" />
              </i>
            </a>
          </div>
          <!--<a class="profilesearchbutton" style="margin-left:10px" (click)="Select_Profiledata(data.data)"><i class="fas fa-check-square"></i> Select</a>-->
        </div>
      </dx-data-grid>



    </div>

  </div>


</div>

